import { render, staticRenderFns } from "./invoising.vue?vue&type=template&id=4dafa59d"
import script from "./invoising.vue?vue&type=script&lang=js"
export * from "./invoising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports